import React, { useEffect, useState, useContext, Fragment } from 'react'
import * as m5 from '@mobiscroll/react5'
import BigNumber from "bignumber.js"
import PullToRefresh from 'react-simple-pull-to-refresh'
import { AppContext } from '../Launcher'

import { styleNumber, numberWithCommas } from '../Helper'
import { getBorrowStockFee, getTax, getTradeFee } from './Transaction'
import stocksOptions from '../dataset/stocks.json'
import dividendInfo from '../dataset/dividend.json'
import moment from 'moment'

export const NOTIFICATION_COLOR = '#f06292'
const dateInWeek = []
const date = moment()
dateInWeek.push(date.format('YYYY-MM-DD'))
while (dateInWeek.length < 7) {
    dateInWeek.push(date.add(1, 'd').format('YYYY-MM-DD'))
}
const recentlyDividend = dividendInfo.filter(d => dateInWeek.indexOf(d.date) > -1).map(d => d.id)


const NotifyDot = ({ id }) => {
    return (recentlyDividend.indexOf(id) > -1 ? <div className="rounded-circle"
        style={{
            backgroundColor: NOTIFICATION_COLOR,
            width: '0.5rem',
            height: '0.5rem',
            position: 'absolute',
            top: 0,
            left: '0.125rem'
        }}></div> : '')
}

const summarize = (data, pzlist, priceConfig, revenueConfig) => {
    const unique = [...new Set(data.map(d => d.id))]
    return unique.map(u => {
        const all = data.filter(d => d.id === u)

        let s = {
            id: u,
            name: all[0].name,
            holdQ: 0,
            price: 0,
            quantity: 0,
            cost: 0,
            expense: 0,
            income: 0,
            pz: 0,
            marketCap: 0,
            revenue: 0,
            roi: 0,
            profit: 0
        }
        all.forEach(a => {
            const fee = a.cfee ? a.cfee : a.cfee === 0 ? 0 : a.fee

            if (a.action === 'sell') {
                s.cost += fee
                s.holdQ -= a.quantity
                s.income += a.amount
            } else if (a.action === 'profit') {
                s.cost += fee
                s.holdQ += a.quantity
                s.income += a.amount
                s.profit += a.amount //股利
            } else {
                s.cost += fee
                s.holdQ += a.quantity
                s.quantity += a.quantity
                s.expense += a.amount
            }
        })
        let mktPrize = pzlist.filter(p => p.id === s.id)
        if (mktPrize.length > 0) {
            mktPrize[0].pz = mktPrize[0].pz ? mktPrize[0].pz : mktPrize[0].y //當日無任何成交 <=1.3.12盤後補價會更新成空值
            s.pz = mktPrize[0].pz
            s.y = mktPrize[0].y
            s.today = new BigNumber((s.pz - s.y)).times(new BigNumber(s.holdQ)).integerValue(BigNumber.ROUND_HALF_CEIL).toNumber()
            s.marketCap = new BigNumber(mktPrize[0].pz).times(new BigNumber(s.holdQ)).integerValue(BigNumber.ROUND_HALF_CEIL).toNumber()
            s.revenue = new BigNumber(s.marketCap).plus(new BigNumber(s.income)).minus(new BigNumber(s.expense)).minus(new BigNumber(s.cost)).toNumber()
            s.roi = parseFloat((s.revenue / (s.expense + s.cost) * 100).toFixed(2))
            s.hl = mktPrize[0].hl
        } else { // 查詢興櫃價格
            const tp = localStorage.getItem('TpexPZ')
            if (tp) {
                mktPrize = JSON.parse(tp).p.filter(p => p.id === s.id)
                if (mktPrize.length > 0) {
                    mktPrize[0].pz = mktPrize[0].pz ? mktPrize[0].pz : mktPrize[0].y
                    s.pz = mktPrize[0].pz
                    s.y = mktPrize[0].y
                    s.today = new BigNumber((s.pz - s.y)).times(new BigNumber(s.holdQ)).integerValue(BigNumber.ROUND_HALF_CEIL).toNumber()
                    s.marketCap = new BigNumber(mktPrize[0].pz).times(new BigNumber(s.holdQ)).integerValue(BigNumber.ROUND_HALF_CEIL).toNumber()
                    s.revenue = new BigNumber(s.marketCap).plus(new BigNumber(s.income)).minus(new BigNumber(s.expense)).minus(new BigNumber(s.cost)).toNumber()
                    s.roi = parseFloat((s.revenue / (s.expense + s.cost) * 100).toFixed(2))
                }
            }
        }

        if (mktPrize.length === 0) {
            if (stocksOptions.some(o => o.id === s.id && o.type === '下市')) { //已下市
                s.pz = 0
                s.y = 0
                s.today = new BigNumber((s.pz - s.y)).times(new BigNumber(s.holdQ)).integerValue(BigNumber.ROUND_HALF_CEIL).toNumber()
                s.marketCap = new BigNumber(0).times(new BigNumber(s.holdQ)).integerValue(BigNumber.ROUND_HALF_CEIL).toNumber()
                s.revenue = new BigNumber(s.marketCap).plus(new BigNumber(s.income)).minus(new BigNumber(s.expense)).minus(new BigNumber(s.cost)).toNumber()
                s.roi = parseFloat((s.revenue / (s.expense + s.cost) * 100).toFixed(2))
            }
        }

        if (revenueConfig === 'pre') { //預扣賣出成本
            const soldAll = {
                id: s.id,
                action: 'sell',
                quantity: s.holdQ,
                amount: s.marketCap,
            }
            const { dealer } = all[all.length - 1] //暫時抓最後一交易使用之券商 //多券商同一檔股票會有問題
            const cost = getTradeFee(soldAll, dealer.dc, dealer.mfr, dealer.mf)
                + getTax(soldAll)
                + getBorrowStockFee(soldAll, dealer.bsf)
            //暫時不扣利息
            s.revenue = s.revenue - cost
            s.roi = parseFloat((s.revenue / (s.expense + s.cost) * 100).toFixed(2))
        }

        s.totalCost = Math.max(s.expense + s.cost - s.income, 0)
        s.price = priceConfig === 'cost' ?
            s.holdQ > 0 && s.totalCost > 0 ? parseFloat((s.totalCost / s.holdQ).toFixed(2)) : 0
            : s.expense > 0 ? parseFloat((s.expense / s.quantity).toFixed(2)) : 0
        return s
    })
}

const colsName = {
    id: '庫存',
    name: '持股',
    totalCost: '成本',
    holdQ: '股數',
    price: '均價',
    marketCap: '市值',
    pz: '現價',
    revenue: '損益',
    roi: '％'
}

const StockRowContent = ({ col, d }) => {
    const { appContext } = useContext(AppContext)
    const isVIP = appContext.vip
    switch (col) {
        case 'id':
            return (
                <>
                    <div className="position-relative">{d.name}
                        {isVIP && <NotifyDot id={d.id} />}
                    </div>
                    <div className="text-muted">{d.id}</div>
                </>
            )
        case 'pz':
            return (
                <div className={d.pz > d.y ? 'text-danger' : d.pz < d.y ? 'text-success' : ''}>
                    {d.hl ?
                        <span className={d.pz > d.y ? 'hl-red px-1' : d.pz < d.y ? 'hl-green px-1' : ''}>
                            {numberWithCommas(d.pz)}
                        </span> :
                        <span>{numberWithCommas(d.pz)}</span>
                    }
                </div>
            )
        case 'revenue':
        case 'roi':
            const v = styleNumber(d[col])
            return <div className={v.color}>{v.number}{col === 'roi' && '%'}</div>
        case 'cost':
            return <div>{numberWithCommas(d.totalCost)}</div>
        case 'holdQ':
            return <div className={d.holdQ < 0 ? 'text-danger' : ''}>{numberWithCommas(d.holdQ)}</div>
        case 'name':
            return (
                <div className="position-relative">{d.name}
                    {isVIP && <NotifyDot id={d.id} />}
                </div>
            )
        default:
            return <div>{numberWithCommas(d[col])}</div>
    }
}

const StockRow = ({ cols, price, d, i, onClick }) => {

    return (
        <tr key={i} onClick={onClick}>
            {
                cols.map((c, i) => (
                    <td key={'c' + i} className="text-center w-25">
                        {c.map((col, j) => <StockRowContent key={'col' + j} price={price} col={col} d={d} />)}
                    </td>
                ))
            }
        </tr>
    )
}

const StockThead = ({ cols, sortedCol, sort, handler, theme }) => {

    const { clickTh, sortedCls } = handler
    const color = theme === 'dark' ? '#ffffff' : '#000000'
    return (
        <thead>
            <tr>
                {
                    cols.map((c, i) =>
                    (
                        <th key={'c' + i} className="text-center w-25 font-weight-normal" style={{ fontSize: 16, color }} scope="col" onClick={() => { clickTh(i) }}>
                            <div className="d-flex justify-content-center align-items-center">
                                <div className='d-flex flex-wrap justify-content-center'>
                                    {
                                        c.map((s, j) => {
                                            if (j === 0) {
                                                return <div key={s} className={sortedCls(i, j)}>{colsName[s]}</div>
                                            } else {
                                                return <React.Fragment key={s} >
                                                    <div style={{
                                                        width: '1px', height: '16px', backgroundColor: color,
                                                        marginTop: '4px', marginLeft: '2px', marginRight: '2px'
                                                    }}></div>
                                                    <div className={sortedCls(i, j)}>{colsName[s]}</div>
                                                </React.Fragment>
                                            }
                                        })
                                    }
                                </div>
                                <Sort sort={sortedCol === i ? sort : 0} />
                            </div>
                        </th>
                    ))
                }
            </tr>
        </thead>
    )
}

const Sort = ({ sort }) => {

    const content = (sort) => {

        switch (sort) {
            case 1:
            case 3:
                return (
                    <>
                        <div style={{ height: '0.75rem', marginTop: '-0.25rem' }}>
                            <i className="bi bi-caret-up" style={{ fontSize: '0.5rem' }}></i>
                        </div>
                        <div style={{ height: '0.75rem', marginTop: '-0.25rem' }}>
                            <i className="bi bi-caret-down-fill" style={{ fontSize: '0.5rem' }}></i>
                        </div>
                    </>
                )
            case 2:
            case 4:
                return (
                    <>
                        <div style={{ height: '0.75rem', marginTop: '-0.25rem' }}>
                            <i className="bi bi-caret-up-fill" style={{ fontSize: '0.5rem' }}></i>
                        </div>
                        <div style={{ height: '0.75rem', marginTop: '-0.25rem' }}>
                            <i className="bi bi-caret-down" style={{ fontSize: '0.5rem' }}></i>
                        </div>
                    </>)
            default:
                return (
                    <>
                        <div style={{ height: '0.75rem', marginTop: '-0.25rem' }}>
                            <i className="bi bi-caret-up" style={{ fontSize: '0.5rem' }}></i>
                        </div>
                        <div style={{ height: '0.75rem', marginTop: '-0.25rem' }}>
                            <i className="bi bi-caret-down" style={{ fontSize: '0.5rem' }}></i>
                        </div>
                    </>
                )
        }
    }

    return (
        <div className="d-flex align-items-start flex-column"
            style={{ height: '1.5rem', marginTop: '-0.125rem', marginLeft: '1px' }}>
            {content(sort)}
        </div>
    )
}

const Stock = React.memo(({ revenueConfig, priceConfig, cols, theme, data, handler, stockPZ }) => {

    const { _sortedCol, _sort } = JSON.parse(localStorage.getItem('sortInfo')) || { _sortedCol: -1, _sort: 0 }
    const tableCls = theme === 'dark' ? 'table-dark' : ''
    const { setTotalData, openArchive } = handler
    const [details, setDetails] = useState(summarize(data, []))
    const [sortedCol, setSortedCol] = useState(_sortedCol)
    const [sort, setSort] = useState(_sort)

    useEffect(() => {
        if (data.length > 0 && stockPZ.length > 0) {
            const sum = summarize(data, stockPZ, priceConfig, revenueConfig) //以股號合併交易結果
            setDetails(sum)
            //計算全部加總結果
            let totalRevenue = 0
            let totalMktCap = 0
            let totalToday = 0
            let totalExpense = 0
            let totalIncome = 0
            let totalCost = 0
            let totalProfit = 0
            let soldNum = sum.filter(d => d.holdQ === 0).length
            let stockNum = sum.length - soldNum
            sum.forEach(s => {
                totalRevenue += s.revenue ? s.revenue : 0
                totalMktCap += s.marketCap ? s.marketCap : 0
                totalToday += s.today ? s.today : 0
                totalExpense += s.expense ? s.expense : 0
                totalIncome += s.income ? s.income : 0
                totalCost += s.cost ? s.cost : 0
                totalProfit += s.profit ? s.profit : 0
            })
            setTotalData({ totalRevenue, totalMktCap, totalToday, totalExpense, totalIncome, totalCost, soldNum, stockNum, totalProfit })
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, stockPZ, priceConfig, revenueConfig])

    const clickTh = (colIdx) => {
        let currSort = sort
        const patterns = cols[colIdx].length * 2
        if (sort < patterns && sortedCol === colIdx) {
            currSort = sort + 1
        } else {
            if (sortedCol === colIdx)
                currSort = 0
            else
                currSort = 1
        }
        setSort(currSort)
        setSortedCol(colIdx)
        localStorage.setItem('sortInfo', JSON.stringify({ _sortedCol: colIdx, _sort: currSort }))
    }

    const sortedCls = (idx, sub) => {
        if (idx === sortedCol) {
            if (sub === 0) {
                if (sort > 0 && sort < 3)
                    return 'font-weight-bold'
            } else {
                if (sort > 2)
                    return 'font-weight-bold'
            }
        }
        return ''
    }

    const dySort = (a, b) => {
        if (sort > 0) {
            let sub = sort > 2 ? 1 : 0
            let target = cols[sortedCol][sub]
            if (target === 'name') { //股名強制改用代號排序
                target = 'id'
            }
            if (sort % 2 === 1)
                return b[target] > a[target] ? '1' : '-1'
            else
                return a[target] >= b[target] ? '1' : '-1'
        } else {
            return 0
        }
    }

    const handleRefresh = () => {
        return new Promise((res) => {
            handler.updatePZ()
            setTimeout(() => {
                res('ok')
            }, 168)
        })
    }

    return (
        <PullToRefresh onRefresh={handleRefresh}>
            <m5.Page className='sb-page-no-safe-top'>
                <table className={'table table-striped tableFixHead ' + tableCls}>
                    <StockThead cols={cols} sortedCol={sortedCol} sort={sort} handler={{ clickTh, sortedCls }} theme={theme} />
                    <tbody>
                        {
                            details.filter(d => d.holdQ !== 0).sort(dySort).map((d, i) => (
                                <StockRow key={i} i={i} cols={cols} d={d} onClick={() => { handler.setHistory({ stockNo: d.id, y: d.y, pz: d.pz }) }} />
                            ))
                        }
                    </tbody>
                </table>
                <div className="mbsc-form-group-title">已結算股票</div>
                <table className={'table table-striped ' + tableCls}>
                    <tbody>
                        {
                            details.filter(d => d.holdQ === 0).sort(dySort).map((d, i) => (
                                <StockRow key={i} i={i} cols={cols} d={d} onClick={() => { handler.setHistory({ stockNo: d.id, y: d.y, pz: d.pz }) }} />
                            ))
                        }
                    </tbody>
                </table>
                {localStorage.getItem('StockInfoPZ') &&
                    <div className="d-flex justify-content-between text-muted w-100 mb-4" style={{ fontSize: '0.75rem' }}>
                        <span className="pl-2">
                            向下拉可觸發更新
                        </span>
                        <span className="pr-2">
                            更新時間：{new Date(JSON.parse(localStorage.getItem('StockInfoPZ')).t * 1000).toLocaleString()}
                        </span>
                    </div>}
                <div className="d-flex justify-content-end mb-4">
                    <button type="button" className="btn btn-secondary rounded-pill m-2 py-2"
                        onClick={openArchive}>
                        已封存
                        <i className="bi bi-arrow-right"></i>
                    </button>
                </div>

            </m5.Page>
        </PullToRefresh>
    )
})

export default Stock